// Spanish for the worker-facing SOS Field app (/field). One file per area; keys are the English text.
import clock from './clock'
import home from './home'
import layout from './layout'
import photos from './photos'
import sales from './sales'
import server from './server'

export default {
  ...layout,
  ...home,
  ...clock,
  ...photos,
  ...sales,
  ...server,
} as Record<string, string>
